module.exports = __webpack_public_path__ + "img/001-spotify.5a7a0a4b.svg";